import { isEqual as _isEqual } from 'lodash-es';

import { ScreenData } from '../shared/screen-data.interface';
import { SigninData } from '../shared/signin-data.interface';
import * as AuthActions from './auth.actions';

const RELOGIN_MAX = 28800;

export interface AuthState {
  authenticated: boolean;
  lastLoginEpoch: number;
  relogin: boolean;
  reloginStatus: string;
  data: SigninData;
  screens: {
    distinctPrevScreen: ScreenData;
    prevScreen: ScreenData;
    currScreen: ScreenData;
    lockRoute: string;
  };
  apiVersion: string;
}

export const initialState: AuthState = {
  authenticated: false,
  lastLoginEpoch: null,
  relogin: false,
  reloginStatus: null,
  data: null,
  screens: {
    distinctPrevScreen: null,
    prevScreen: null,
    currScreen: null,
    lockRoute: null,
  },
  apiVersion: null,
};

export function authReducer(state = initialState, action: AuthActions.AuthActions) {
  switch (action.type) {
    case AuthActions.LOGIN:
      if (
        state.authenticated === true &&
        state.screens &&
        state.screens.currScreen &&
        state.screens.currScreen.route &&
        state.lastLoginEpoch &&
        Math.floor(Date.now() / 1000) - state.lastLoginEpoch <= RELOGIN_MAX
      ) {
        return {
          ...state,
          lastLoginEpoch: Math.floor(Date.now() / 1000),
          relogin: true,
          data: action.payload as SigninData,
          apiVersion: state.apiVersion,
        };
      }

      return {
        ...initialState,
        authenticated: true,
        lastLoginEpoch: Math.floor(Date.now() / 1000),
        data: action.payload as SigninData,
        reloginStatus: null,
        apiVersion: state.apiVersion,
      };

    case AuthActions.LOGOUT:
      return {
        ...state,
        authenticated: false,
        lastLoginEpoch: null,
        data: null,
        reloginStatus: null,
      };

    case AuthActions.UPDATE_SESSION_DATA:
      return {
        ...state,
        data: action.payload,
      };

    case AuthActions.CHANGE_CUSTOMER:
      return {
        ...state,
        data: {
          ...state.data,
          custid: action.custid,
        },
      };

    case AuthActions.UPDATE_HAS_PASSTHRU_DATA:
      return {
        ...state,
        data: {
          ...state.data,
          haspassthru: action.haspassthru,
        },
      };

    case AuthActions.CHANGE_FACILITY:
      return {
        ...state,
        data: {
          ...state.data,
          facility: action.payload,
        },
      };

    case AuthActions.CHANGE_SCREEN:
      return {
        ...state,
        screens: {
          ...state.screens,
          distinctPrevScreen: _isEqual({ ...state.screens.currScreen }, action.screen)
            ? { ...state.screens.distinctPrevScreen }
            : { ...state.screens.currScreen },
          prevScreen: { ...state.screens.currScreen },
          currScreen: action.screen,
        },
      };

    case AuthActions.LOCK_ROUTE:
      return {
        ...state,
        screens: {
          ...state.screens,
          lockRoute: action.route,
        },
      };

    case AuthActions.UNLOCK_ROUTE:
      return {
        ...state,
        screens: {
          ...state.screens,
          lockRoute: null,
        },
      };

    case AuthActions.RELOGIN_STATUS:
      return {
        ...state,
        reloginStatus: action.status,
      };

    case AuthActions.SET_API_VERSION:
      return {
        ...state,
        apiVersion: action.version,
      };

    default:
      return state;
  }
}
